(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsContainer = document.querySelector('.custom--tabs');
    let isMobile = window.innerWidth < 500;

    // Initialize active tab
    let activeTab = document.querySelector('.tab__list.active');
    let activeContent = document.querySelector('.custom__tab-content.active');
    if (activeTab && activeContent) {
      activeTab.classList.add('active');
      activeContent.classList.add('active');
    }

    // Event delegation for tab clicks
    tabsContainer.addEventListener('click', function (e) {
      const tab = e.target.closest('.custom-tab');
      if (!tab) return;

      const tabList = tab.closest('.tab__list');
      const contentId = tab.dataset.contentId;
      const content = document.getElementById(contentId);

      if (!content) return;

      // Remove active classes
      document.querySelectorAll('.tab__list').forEach(list => list.classList.remove('active'));
      document.querySelectorAll('.custom__tab-content').forEach(c => c.classList.remove('active'));

      // Add active classes
      tabList.classList.add('active');
      content.classList.add('active');

      // Mobile behavior: Move content below active tab
      if (isMobile && content) {
        tabList.insertAdjacentElement('afterend', content);
      }
    });

    // Handle window resize for mobile/desktop switch
    window.addEventListener('resize', function () {
      isMobile = window.innerWidth < 500;
      if (isMobile && activeContent) {
        activeTab.insertAdjacentElement('afterend', activeContent);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
